// Object.fromEntries - Android 8 compatibility

export function fromEntries<T extends Record<string, unknown> = Record<string, unknown>>(
   entries: [string, unknown][],
): T {
   return entries.reduce<T>((result: T, e: [string, unknown]) => {
      // @ts-ignore
      result[e[0]] = e[1];
      return result;
   }, {} as T);
}

if (!Object.fromEntries) Object.fromEntries = fromEntries;
